import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DOMAIN_ENVIRONMENT } from 'src/app/_services/base.service';
import { PlatformService } from 'src/app/_services/platform.service';
import { SharedModule } from 'src/app/_shared/_shared.module';
import { DiasRestantesComponent } from 'src/app/_shared/bloque-ficha/dias-restantes/dias-restantes.component';
import { ProgressBarComponent } from 'src/app/_shared/bloque-ficha/progress-bar/progress-bar.component';
import { MinifichaAudiovisual } from 'src/app/creative/public/_models/minificha-audiovisual';
import { TagEstadoRondaCreativeComponent } from 'src/app/creative/shared/utils/tag-estado-ronda-creative/tag-estado-ronda-creative.component';
import { TagsAudiovisualComponent } from 'src/app/creative/shared/utils/tags-audiovisual/tags-audiovisual.component';
import { TagOverfundingComponent } from 'src/app/_shared/bloque-tags/tag-overfunding/tag-overfunding.component';


@Component({
  selector: 'app-ficha-op-abierta-audiovisual',
  templateUrl: './ficha-op-abierta-audiovisual.component.html',
  styleUrls: ['./ficha-op-abierta-audiovisual.component.scss'],
  standalone: true,
  imports: [
    SharedModule,
    RouterModule,
    TagOverfundingComponent,
    TagEstadoRondaCreativeComponent,
    TagsAudiovisualComponent,
    DiasRestantesComponent,
    ProgressBarComponent
  ]
})
export class FichaOpAbiertaAudiovisualComponent
{
  @Input() totalOportunidades: number;
  @Input() oportunidad: MinifichaAudiovisual;
  @Input() ref: string;
  creativeDomainUrl: string;
  plataformaId: string;
  showTagSobrefinanciado: boolean = false;

  constructor(private _platformService: PlatformService)
  {
    this.creativeDomainUrl = this._platformService.getSubdominioUrl('creative');
    this.plataformaId = DOMAIN_ENVIRONMENT[this._platformService._domainEnvironment];
  }

  ngOnInit(): void{
    this.mostrarTagSobrefinanciado();
  }

  private mostrarTagSobrefinanciado(): void {
    const condition: boolean = (this.oportunidad.tipoEstadoRondaId === 'en-financiacion' && this.oportunidad.isOverfunding && this.oportunidad.porcentajeFinanciado >= 100);
    this.showTagSobrefinanciado = condition ? true : false;
  }
}
